import type { components } from '@pba/types-openapi-client';
import { parseISO } from 'date-fns';
import type { CommunitySlim } from '../community';
import type { BaseContentObjectDataObject } from '../service';
import { type UploadedFile, createUploadedFile } from '../uploaded-file';
import { type UserList, createUserList } from '../user';

type ContentObjectAuthor = UserList;

export const createContentObjectAuthor = (data: components['schemas']['UserList']): ContentObjectAuthor => ({
  ...createUserList(data),
});

export type BaseContentObject = {
  attachments: UploadedFile[];
  author: UserList;
  bookmarked: boolean;
  commentsCount: number;
  // TODO: need discussion about this field, if its better to split it to contentable base content object and base content object
  contentableId?: string;
  createdAt: Date;
  htmlContent: null | string;
  id: string;
  liked: boolean;
  likesCount: number;
  name: string;
  parentId: null | string;
  pinned: boolean;
  postInCommunities?: [CommunitySlim];
  publishAt: Date;
  textContent: string;
  updatedAt: Date;
};

export const createBaseContentObject = (data: BaseContentObjectDataObject): BaseContentObject => ({
  attachments: data.attachments.map((attachment) => createUploadedFile(attachment)),
  author: createContentObjectAuthor(data.author),
  bookmarked: data.bookmarked,
  commentsCount: data.comments_count,
  contentableId: data.contentable_id,
  createdAt: parseISO(data.created_at),
  htmlContent: data.html_content,
  id: data.id,
  liked: data.liked,
  likesCount: data.likes_count,
  name: data.name,
  parentId: data.parent_id,
  pinned: data.pinned,
  publishAt: parseISO(data.publish_at),
  textContent: data.text_content,
  updatedAt: parseISO(data.updated_at),
});
